// extracted by mini-css-extract-plugin
module.exports = {"page":"Help_page__hQhl5","article":"Help_article__0SDRX","lead":"Help_lead__925Gj","note":"Help_note__94JXj"};